import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/hot/image/hot-title.png'
import _imports_1 from '@/assets/hot/image/question.png'


const _withScopeId = n => (_pushScopeId("data-v-3fd70e01"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"126.1px","height":"32.5px"},
  alt: "九方热榜"
}, null, -1))
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"width":"350px"} }, "九方智投用户正在关注这些内容。依据交易数据、标的涨幅、市场舆情、用户关注度4大维度筛选高热度标的。", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"14px","height":"14px"},
  alt: "信息"
}, null, -1))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = {
  key: 0,
  class: "text-left"
}
const _hoisted_9 = {
  key: 0,
  style: {"margin-left":"8px"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("即时排名： 第 ")
const _hoisted_11 = { style: {"color":"red"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 名")
const _hoisted_13 = {
  key: 1,
  style: {"margin-left":"8px"}
}
const _hoisted_14 = {
  key: 1,
  class: "text-right"
}
const _hoisted_15 = { class: "box1" }
const _hoisted_16 = { class: "left" }
const _hoisted_17 = { class: "right" }
const _hoisted_18 = { class: "rightTitle" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 实时变动 ")
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { style: {"color":"red","margin-right":"2px"} }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("名 ")
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { style: {"color":"green","margin-right":"2px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("名 ")
const _hoisted_26 = {
  key: 2,
  style: {"margin-left":"2px"}
}
const _hoisted_27 = {
  key: 1,
  style: {"margin-left":"2px"}
}
const _hoisted_28 = {
  key: 0,
  id: "echarts1",
  class: "chart"
}
const _hoisted_29 = {
  key: 1,
  class: "chart"
}
const _hoisted_30 = {
  key: 2,
  class: "rightTitle"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 历史趋势 较昨日 ")
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 持平 ", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 名 ")
const _hoisted_37 = { key: 2 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " — ", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 3,
  class: "rightTitle"
}
const _hoisted_41 = {
  key: 4,
  id: "echarts2",
  class: "chart"
}
const _hoisted_42 = {
  key: 5,
  class: "chart"
}
const _hoisted_43 = { class: "box1" }
const _hoisted_44 = { class: "box1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Table = _resolveComponent("Table")!
  const _component_ArrowUpOutlined = _resolveComponent("ArrowUpOutlined")!
  const _component_ArrowDownOutlined = _resolveComponent("ArrowDownOutlined")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_tabs_pane = _resolveComponent("a-tabs-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    spinning: _ctx.hotListLoading,
    tip: "加载中...",
    wrapperClassName: "hot-spin-wrapper"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["wrapper hot-wrapper", { 'dark-theme': _ctx.theme === 'dark' }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_a_popover, {
                placement: "right",
                overlayClassName: "de-popover"
              }, {
                content: _withCtx(() => [
                  _hoisted_5
                ]),
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_Select, {
            onCheckStock: _ctx.checkStock,
            source: "hot",
            tags: _ctx.tags
          }, null, 8, ["onCheckStock", "tags"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "textInfo",
            style: _normalizeStyle({ color: _ctx.theme === 'dark' ? '#fff' : '#000' })
          }, [
            (_ctx.activeKey == 1 && _ctx.hotCur && _ctx.hotCur?.symbol)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.hotCur?.name) + " (" + _toDisplayString(_ctx.hotCur?.symbol) + ")", 1),
                  (_ctx.hotCur?.index)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.hotCur?.index), 1),
                        _hoisted_12
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, "即时排名：—"))
                ]))
              : _createCommentVNode("", true),
            (_ctx.upTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, "更新时间:" + _toDisplayString(_ctx.upTime), 1))
              : _createCommentVNode("", true)
          ], 4),
          _createVNode(_component_a_tabs, {
            activeKey: _ctx.activeKey,
            "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
            onTabClick: _ctx.tabClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs_pane, {
                key: "1",
                tab: "热股榜"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_Table, {
                        theme: _ctx.theme,
                        data: _ctx.tableData,
                        columns: _ctx.columns1,
                        bordered: false,
                        style: {"height":"calc(100vh - 300px)","width":"100%"},
                        pagination: false,
                        customRow: _ctx.customRow,
                        setRowClassName: _ctx.setRowClassName
                      }, null, 8, ["theme", "data", "columns", "customRow", "setRowClassName"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        (_ctx.hotCur && _ctx.hotCur.rankChange !== undefined)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.hotCur.rankChange > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                    _createElementVNode("span", _hoisted_21, [
                                      _createVNode(_component_ArrowUpOutlined),
                                      _createTextVNode(_toDisplayString(_ctx.hotCur.rankChange), 1)
                                    ]),
                                    _hoisted_22
                                  ]))
                                : (_ctx.hotCur.rankChange < 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                      _createElementVNode("span", _hoisted_24, [
                                        _createVNode(_component_ArrowDownOutlined),
                                        _createTextVNode(_toDisplayString(Math.abs(_ctx.hotCur.rankChange)), 1)
                                      ]),
                                      _hoisted_25
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_26, "持平"))
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_27, "—"))
                      ]),
                      (_ctx.hasChartData1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                        : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createVNode(_component_Nodata, {
                              mode: "vertical",
                              customdesc: "暂无实时变动数据"
                            })
                          ])),
                      (_ctx.hotCur)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("span", null, [
                              _hoisted_31,
                              (_ctx.hotCur.hisRankChange === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _hoisted_34))
                                : (_ctx.hotCur.hisRankChange)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                      _createElementVNode("span", {
                                        style: _normalizeStyle(_ctx.hotCur.hisRankChange > 0 ? 'color:red' : _ctx.hotCur.hisRankChange < 0 ? 'color:green' : '')
                                      }, [
                                        (_ctx.hotCur.hisRankChange > 0)
                                          ? (_openBlock(), _createBlock(_component_ArrowUpOutlined, {
                                              key: 0,
                                              style: {"color":"red"}
                                            }))
                                          : (_ctx.hotCur.hisRankChange < 0)
                                            ? (_openBlock(), _createBlock(_component_ArrowDownOutlined, {
                                                key: 1,
                                                style: {"color":"green"}
                                              }))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(_ctx.hotCur.hisRankChange), 1)
                                      ], 4),
                                      _hoisted_36
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_37, _hoisted_39))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_40, "历史趋势")),
                      (_ctx.hasChartData2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41))
                        : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createVNode(_component_Nodata, {
                              mode: "vertical",
                              customdesc: "暂无历史趋势数据",
                              pagetheme: String(_ctx.theme)
                            }, null, 8, ["pagetheme"])
                          ]))
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_tabs_pane, {
                key: "2",
                tab: "概念榜"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_Table, {
                      theme: _ctx.theme,
                      data: _ctx.tableData,
                      columns: _ctx.columns,
                      bordered: false,
                      pagination: false,
                      style: {"width":"100%","margin":"0 auto"},
                      customRow: _ctx.customRow2
                    }, null, 8, ["theme", "data", "columns", "customRow"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_tabs_pane, {
                key: "3",
                tab: "行业榜"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_Table, {
                      theme: _ctx.theme,
                      data: _ctx.tableData,
                      columns: _ctx.columns,
                      bordered: false,
                      pagination: false,
                      style: {"width":"100%","margin":"0 auto"},
                      customRow: _ctx.customRow2
                    }, null, 8, ["theme", "data", "columns", "customRow"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeKey", "onTabClick"])
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["spinning"]))
}